module.exports = __webpack_public_path__ + "img/christine-pro.f49f0313.jpg";